export default __webpack_public_path__ + "static/media/smart-ideas.1ab60c9e.svg";